import { createContext, useContext } from 'react';
import { Navigate, Outlet } from 'react-router';
import { ParkingaboAsyncLoadedSection } from './ParkingaboAsyncLoadedSection.tsx';
import { useServerFetch } from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';
import { useParamOperatorExternalId } from '../CustomerProvider.tsx';

export const UnauthenticatedOperatorContext =
    createContext<UnauthenticatedOperator | null>(null);

export function UnauthenticatedOperatorContextProvider() {
    const operatorExternalId = useParamOperatorExternalId();
    const [unauthenticatedOperatorState] = useServerFetch<
        UnauthenticatedOperator,
        { operatorExternalId: string }
    >(
        ({ operatorExternalId }) => ({
            url: `/ui-api/parkingabo/unauthenticated-operator/${operatorExternalId}`,
        }),
        operatorExternalId ? { operatorExternalId } : null,
    );

    if (!operatorExternalId) {
        return <Navigate to={'/login'} />;
    }

    return (
        <ParkingaboAsyncLoadedSection
            state={unauthenticatedOperatorState}
            render={unauthenticatedOperator => (
                <UnauthenticatedOperatorContext.Provider
                    value={unauthenticatedOperator}
                >
                    <Outlet />
                </UnauthenticatedOperatorContext.Provider>
            )}
        />
    );
}

export function useUnauthenticatedOperator(): UnauthenticatedOperator {
    const context = useContext(UnauthenticatedOperatorContext);
    if (!context) {
        throw new Error(
            'useUnauthenticatedOperator must be used within the context',
        );
    }
    return context;
}

interface UnauthenticatedOperator {
    operatorExternalId: string;
    allowSignup: boolean;
}
